import { useQuery } from "@tanstack/react-query";
import { getPartTypesMetricLimits } from "../../repositories/MetricLimitsRepository";
import type { PartTypeMetricLimits } from "../../models/metricLimits.models";

export const useMetricLimitsQuery = (
  parentPartTypeIds?: string,
  onError?: (error: Error) => void,
) => {
  return useQuery({
    queryKey: ["metric-limits", parentPartTypeIds ?? "all"],
    queryFn: async ({ signal }) => {
      const resp = await getPartTypesMetricLimits(parentPartTypeIds, signal);
      if (resp.ok) {
        return (resp.data?.tables?.[0]?.rows ?? []) as PartTypeMetricLimits[];
      }
      throw new Error(resp.message);
    },
    onError,
  });
};
